import * as React from 'react';
import { Page } from '../page';
import { ticketColors } from '../../utils/ticketColors';
import { InfoContainer, ColorLine, InfoContent, TicketType, BoldText,
  Row, TicketNo, Description, Status, InfoWrap, InfoHeader, MessageContainer, AddMessageWrap, AddMessageBtn } from './ticket.styles';
import * as dateformat from 'dateformat';
import { ChatMesssage } from '../../components/blocks/chatMessage/chatMessage';

interface Message {
  user: {
    id: string;
    name: string;
  };
  timestamp: number;
  text: string;
}

interface Props {
  number: string;
  userId: string;
}

interface State {
  ticket: MaintenanceTicket;
  messages: Message[];
}

export class TicketPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      ticket: null,
      messages: []
    };
  }

  public componentDidMount() {
    this.setState({
      ticket: {
        type: 'Plumbing',
        title: 'Broken Steam - Bathroom',
        number: 1254756,
        timestamp: Date.now(),
        status: 'received',
        description: 'The steam is leaking and it doesnt work at all and e' +
                     'The steam is leaking and it doesnt work at The steam '
      },
      messages: [
        {
          user: {
            id: 'bentzi',
            name: 'Bentzi Riefer'
          },
          timestamp: Date.now(),
          text: 'Veranda, I will have the plumber there tommorrow at 3:00 tommorrow. please confirm that you wil be available'
        },
        {
          user: {
            id: 'veranda',
            name: 'Veranda '
          },
          timestamp: Date.now(),
          text: 'I have an appointment tommorow lets do wednesday'
        },
        {
          user: {
            id: 'bentzi',
            name: 'Bentzi Riefer'
          },
          timestamp: Date.now(),
          text: 'Veranda, I will have the plumber there tommorrow at 3:00 tommorrow. please confirm that you wil be available'
        },
      ]
    });
  }

  public render() {
    return (
      <Page title={`Ticket #${this.props.number}`} tabNavigation={true}>
        {this.renderInfo()}
        {this.renderMessages(this.state.messages)}
      </Page>
    );
  }

  public renderInfo() {
    if (!this.state.ticket) {
      return null;
    }

    const {mainColor, lineColor, status} = ticketColors(this.state.ticket);
    const timeString =  dateformat(new Date(this.state.ticket.timestamp), 'mm/dd/yyyy');

    return (
      <InfoContainer>
        <InfoWrap>
          <ColorLine color={lineColor}/>
          <InfoContent>
            <Row>
              <InfoHeader>
                <TicketType>{this.state.ticket.type}</TicketType>
                <TicketNo>#{this.state.ticket.number}</TicketNo>
              </InfoHeader>
            </Row>
            <Row>
              <BoldText>{this.state.ticket.title}</BoldText><br />
              <Description>{this.state.ticket.description}</Description>
            </Row>
            <Row>
              <BoldText>Submited on {timeString} by <a href='#' style={{color: `rgb(17, 133, 249)`}}>Veranda Baker</a></BoldText>
            </Row>
            <Row>
              <BoldText>Status: </BoldText><Status color={mainColor}>{status}</Status>
            </Row>
          </InfoContent>
        </InfoWrap>
      </InfoContainer>
    );
  }

  public renderMessages(messages: Message[]) {
    const messageEls = messages.map((message) =>
      <ChatMesssage
        isMe={message.user.id === this.props.userId}
        author={message.user.name}
        timestamp={message.timestamp}
        text={message.text}
      />
    );

    return (
      <MessageContainer>
        <AddMessageWrap>
          <AddMessageBtn icon={require('../../../assets/icons/plus.svg')} />
        </AddMessageWrap>
        {messageEls}
      </MessageContainer>
    );
  }
}
